import { db } from "../firebase";
import {
  doc,
  setDoc,
  getDoc,
  updateDoc,
  deleteDoc,
  arrayUnion,
  collection,
  getDocs, // Import getDocs for fetching documents
} from "firebase/firestore";

// New function to fetch all roles from the UserRoles collection
export const getAllUserRoles = async () => {
  try {
    const rolesCollection = collection(db, "UserRoles");
    const rolesSnapshot = await getDocs(rolesCollection);
    const rolesList = rolesSnapshot.docs.map((doc) => doc.data().name);
    return rolesList;
  } catch (error) {
    console.error("Error fetching user roles: ", error);
    throw error;
  }
};

export const addUserToGroup = async (userId, groupName) => {
  console.log("addUserToGroup", userId, groupName);
  try {
    const groupRef = doc(db, "UserGroups", groupName);
    await updateDoc(groupRef, {
      users: arrayUnion(userId),
    });
    console.log(`User ${userId} added to group ${groupName}`);
  } catch (error) {
    console.error("Error adding user to group: ", error);
    throw error;
  }
};

export const createDocument = async (collectionName, docId, data) => {
  try {
    await setDoc(doc(db, collectionName, docId), data);
    console.log(`Document ${docId} created in collection ${collectionName}`);
  } catch (error) {
    console.error("Error creating document: ", error);
    throw error;
  }
};

export const getDocument = async (collectionName, docId) => {
  try {
    const docRef = doc(db, collectionName, docId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      console.log("No such document!");
      return null;
    }
  } catch (error) {
    console.error("Error getting document: ", error);
    throw error;
  }
};

export const updateDocument = async (collectionName, docId, data) => {
  try {
    const docRef = doc(db, collectionName, docId);
    await updateDoc(docRef, data);
    console.log(`Document ${docId} in collection ${collectionName} updated`);
  } catch (error) {
    console.error("Error updating document: ", error);
    throw error;
  }
};

export const deleteDocument = async (collectionName, docId) => {
  try {
    const docRef = doc(db, collectionName, docId);
    await deleteDoc(docRef);
    console.log(`Document ${docId} in collection ${collectionName} deleted`);
  } catch (error) {
    console.error("Error deleting document: ", error);
    throw error;
  }
};
